import React from 'react';
import './App.css';
import { Navbar } from 'react-bootstrap';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

// Routes
import Login from './Routes/Login'
import PrivateRoute from './Routes/PrivateRoute'
import NewMessage from './Routes/NewMessage'
import Sent from './Routes/Sent'
import Logout from './Routes/Logout'
import Home from './Routes/Home'
import Contacts from './Routes/Contacts'
import Groups from './Routes/Groups/Groups'
import API from './API';

// TODO: explore router -> <Redirect to="/thumbs" />
// https://blog.logrocket.com/conquer-navigation-state-with-react-router-and-redux-f1beb9b8ea7c/

// TODO: support longer lived sessions

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      session: null,
    }
  }
  componentDidMount() {
    API.session().then(response => {
      // If we have a valid response, user has an active session
      console.log(response)
      this.sessionDidUpdate(true, () => {} )
    }, error => {
      this.sessionDidUpdate(false, () => {} )
    })
  }
  sessionDidUpdate(isActive, completion) {
    this.setState({ session: isActive }, () => {
      if (completion){
        completion()
      }
    })
  }
  render() {

    return (
      <Router>
          <Navbar bg="dark" variant="dark">
            <Navbar.Brand href="#home">ECFC Communication Center</Navbar.Brand>
          </Navbar>
          <Switch>
            <PrivateRoute path="/message/new" session={this.state.session} component={NewMessage} />
            <PrivateRoute path="/sent" session={this.state.session} component={Sent} />
            <PrivateRoute path="/contacts" session={this.state.session} component={Contacts} />
            <PrivateRoute path="/groups" session={this.state.session} component={Groups} />
            <Route path="/login"  render={(props) => <Login {...props} sessionDidUpdate={this.sessionDidUpdate.bind(this)} />} />
            <Route path="/logout" render={(props) => <Logout {...props} sessionDidUpdate={this.sessionDidUpdate.bind(this)} />} />
            <PrivateRoute path="/" session={this.state.session} component={Home} />
          </Switch>
        </Router>
    );
  }
}

export default App;
